module.exports = __webpack_public_path__ + "img/软件服务企业办公.e58075ac.jpg";